import styled from "styled-components";

export const ServicesContainer = styled.section`
  background: #f8f9fc;
  padding: 85px 0 60px 0;
  position: relative;
  overflow: hidden;
  border-top: 1px solid #e3e7f3;
`;

export const ServicesWrapper = styled.div`
  width: 92%;
  max-width: 1080px;
  margin: 0 auto;

  @media (max-width: 768px) {
    width: 95%;
  }
`;

export const ServiceHeaderArea = styled.div`
  text-align: center;
  max-width: 860px;
  margin: 0 auto 35px auto;

  .badge-tag {
    display: inline-block;
    background: rgba(40, 6, 249, 0.08);
    color: #2806f9;
    font-weight: 700;
    font-size: 13px;
    letter-spacing: 1.5px;
    text-transform: uppercase;
    padding: 6px 18px;
    border-radius: 30px;
    margin-bottom: 14px;
    border: 1px solid rgba(40, 6, 249, 0.22);
  }

  h2 {
    color: #0c1538;
    font-size: 38px;
    font-weight: 800;
    line-height: 1.25;
    margin-bottom: 14px;

    span {
      color: #2806f9;
    }

    @media (max-width: 768px) {
      font-size: 28px;
    }
  }

  p.subtext {
    color: #4a5168;
    font-size: 16.5px;
    line-height: 1.6;
    margin-bottom: 18px;
  }

  .coverage-pill {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background: #0c1538;
    color: #ffffff;
    font-size: 13.5px;
    padding: 8px 18px;
    border-radius: 25px;
    box-shadow: 0 4px 14px rgba(12, 21, 56, 0.18);

    .flag-icon {
      font-size: 16px;
    }

    @media (max-width: 768px) {
      font-size: 12px;
      padding: 6px 14px;
    }
  }
`;

export const HeroVisualCard = styled.div`
  background: #0c1538;
  border-radius: 20px;
  overflow: hidden;
  margin-bottom: 45px;
  box-shadow: 0 16px 36px rgba(40, 6, 249, 0.09);
  border: 1px solid #1e2954;
  position: relative;
  display: flex;
  flex-direction: column;

  .hero-img-wrap {
    position: relative;
    width: 100%;
    max-height: 380px;
    overflow: hidden;
    background: #000;
    cursor: pointer;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
      transition: transform 0.5s ease;
    }

    &:hover img {
      transform: scale(1.03);
    }

    .hero-overlay-tag {
      position: absolute;
      top: 16px;
      left: 16px;
      background: rgba(12, 21, 56, 0.88);
      backdrop-filter: blur(8px);
      color: #5d44ff;
      font-size: 12.5px;
      font-weight: 700;
      letter-spacing: 1px;
      text-transform: uppercase;
      padding: 6px 14px;
      border-radius: 20px;
      border: 1px solid rgba(93, 68, 255, 0.5);
    }

    .hero-zoom-btn {
      position: absolute;
      bottom: 16px;
      right: 16px;
      background: rgba(0, 0, 0, 0.75);
      backdrop-filter: blur(8px);
      color: #ffffff;
      font-size: 13px;
      font-weight: 600;
      padding: 8px 16px;
      border-radius: 25px;
      border: 1px solid rgba(255, 255, 255, 0.3);
      display: flex;
      align-items: center;
      gap: 6px;
      cursor: pointer;
      transition: all 0.2s ease;

      &:hover {
        background: #2806f9;
        color: #ffffff;
      }
    }
  }

  .hero-strip {
    padding: 16px 24px;
    background: #141f48;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;

    .strip-text {
      color: #ffffff;
      font-size: 14.5px;
      font-weight: 600;
      display: flex;
      align-items: center;
      gap: 10px;

      span.highlight {
        color: #ffffff;
        font-weight: 700;
      }
    }

    .strip-actions {
      display: flex;
      align-items: center;
      gap: 12px;

      a.strip-hotline {
        color: #ffffff;
        font-size: 13.5px;
        text-decoration: none;
        display: flex;
        align-items: center;
        gap: 6px;
        background: rgba(255, 255, 255, 0.12);
        padding: 6px 14px;
        border-radius: 20px;
        transition: background 0.2s;

        &:hover {
          background: rgba(255, 255, 255, 0.22);
        }
      }
    }
  }
`;

export const CategoryFilterRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
  margin-bottom: 40px;

  @media (max-width: 575px) {
    gap: 7px;
    margin-bottom: 25px;
  }

  button {
    background: #ffffff;
    border: 1.5px solid #d4daf0;
    color: #1a2240;
    padding: 9px 20px;
    border-radius: 25px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.25s ease;
    display: flex;
    align-items: center;
    gap: 8px;

    @media (max-width: 575px) {
      font-size: 12.5px;
      padding: 7px 14px;
      gap: 5px;
    }

    &:hover {
      border-color: #2806f9;
      color: #2806f9;
      background: #f0f2ff;
    }

    &.active {
      background: #2806f9;
      border-color: #2806f9;
      color: #ffffff;
      box-shadow: 0 4px 14px rgba(40, 6, 249, 0.3);
    }
  }
`;

export const ServicesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 200px));
  justify-content: center;
  gap: 12px;
  margin-bottom: 45px;

  @media (max-width: 1100px) {
    grid-template-columns: repeat(3, minmax(0, 220px));
    gap: 14px;
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, minmax(0, 220px));
    gap: 12px;
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    gap: 12px;
  }
`;

export const ServiceVisualCard = styled.div`
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #e1e6f5;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.04);
  transition: all 0.25s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 24px rgba(40, 6, 249, 0.12);
    border-color: #2806f9;
  }

  .visual-frame {
    position: relative;
    width: 100%;
    height: 140px;
    background: #f5f7fa;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid #edf1fa;
    padding: 0;

    @media (max-width: 480px) {
      height: 175px;
    }

    .backdrop-blur {
      position: absolute;
      inset: -20px;
      background-size: cover;
      background-position: center;
      filter: blur(18px);
      opacity: 0.18;
      transform: scale(1.2);
      pointer-events: none;
    }

    .category-chip {
      position: absolute;
      top: 6px;
      right: 6px;
      background: rgba(12, 21, 56, 0.88);
      backdrop-filter: blur(6px);
      color: #ffffff;
      font-size: 9px;
      font-weight: 700;
      padding: 3px 7px;
      border-radius: 4px;
      letter-spacing: 0.3px;
      z-index: 2;
      pointer-events: none;
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
    }

    img.service-photo {
      position: relative;
      z-index: 1;
      width: 100%;
      height: 100%;
      object-fit: contain;
      display: block;
      margin: auto;
      transition: transform 0.25s ease;
    }

    &:hover img.service-photo {
      transform: scale(1.05);
    }
  }

  .card-content {
    padding: 10px 10px 12px 10px;
    display: flex;
    flex-direction: column;
    flex-grow: 1;

    @media (max-width: 480px) {
      padding: 14px 14px 16px 14px;
    }
  }

  h3.service-title {
    font-size: 12.5px;
    font-weight: 800;
    color: #0c1538;
    margin-bottom: 6px;
    line-height: 1.25;
    letter-spacing: 0.2px;
    min-height: 32px;
    display: flex;
    align-items: center;

    @media (max-width: 480px) {
      font-size: 15px;
      min-height: auto;
      margin-bottom: 8px;
    }
  }

  .service-features-list {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin: 2px 0 10px 0;
    flex-grow: 1;

    @media (max-width: 480px) {
      gap: 6px;
      margin: 4px 0 12px 0;
    }
  }

  .service-feature-item {
    display: flex;
    align-items: center;
    background: #f4f6fc;
    color: #2806f9;
    font-size: 9.5px;
    font-weight: 700;
    letter-spacing: 0.2px;
    text-transform: uppercase;
    padding: 4px 6px;
    border-radius: 4px;
    border-left: 2.5px solid #2806f9;
    line-height: 1.25;

    @media (max-width: 480px) {
      font-size: 11px;
      padding: 6px 8px;
    }
  }

  .card-footer {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 6px;
    border-top: 1px solid #f0f3fa;
    margin-top: auto;
  }

  .call-btn {
    width: 100%;
    color: #ffffff;
    background: #2806f9;
    font-size: 11px;
    font-weight: 700;
    text-decoration: none;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 6px 10px;
    border-radius: 16px;
    transition: all 0.2s ease;
    box-shadow: 0 2px 8px rgba(40, 6, 249, 0.16);

    @media (max-width: 480px) {
      font-size: 13px;
      padding: 10px 14px;
      border-radius: 20px;
    }

    &:hover {
      background: #1e03c2;
      color: #ffffff;
      transform: translateY(-1px);
    }
  }
`;

export const TrustBarContainer = styled.div`
  background: #0c1538;
  border-radius: 20px;
  padding: 34px 28px;
  color: #ffffff;
  margin-bottom: 35px;
  box-shadow: 0 10px 30px rgba(12, 21, 56, 0.18);

  .trust-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 22px;

    @media (max-width: 991px) {
      grid-template-columns: repeat(2, 1fr);
      gap: 18px;
    }

    @media (max-width: 575px) {
      grid-template-columns: 1fr;
      gap: 14px;
    }
  }

  .trust-item {
    display: flex;
    align-items: center;
    gap: 14px;

    .trust-icon {
      width: 46px;
      height: 46px;
      min-width: 46px;
      background: rgba(255, 255, 255, 0.1);
      border: 1px solid rgba(255, 255, 255, 0.2);
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      color: #6a52ff;
    }

    .trust-text {
      h4 {
        font-size: 14.5px;
        font-weight: 700;
        margin: 0 0 2px 0;
        color: #ffffff;
      }
      p {
        font-size: 12px;
        color: #b7c0de;
        margin: 0;
      }
    }
  }
`;

export const BottomCalloutBanner = styled.div`
  background: linear-gradient(135deg, #182559 0%, #0c1538 100%);
  border-radius: 20px;
  padding: 32px 36px;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 25px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    padding: 24px 18px;
    flex-direction: column;
    text-align: center;
  }

  .left-content {
    h3 {
      font-size: 23px;
      font-weight: 800;
      margin-bottom: 8px;
      color: #ffffff;

      span {
        color: #6a52ff;
      }
    }

    p {
      color: #cad1ea;
      margin: 0;
      font-size: 14.5px;
    }

    .contact-chips {
      display: flex;
      flex-wrap: wrap;
      gap: 14px;
      margin-top: 14px;

      @media (max-width: 768px) {
        justify-content: center;
      }

      .chip {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        background: rgba(255, 255, 255, 0.12);
        padding: 6px 14px;
        border-radius: 30px;
        font-size: 13.5px;
        color: #ffffff;
        text-decoration: none;
        transition: background 0.2s;

        &:hover {
          background: rgba(255, 255, 255, 0.22);
          color: #ffffff;
        }

        svg {
          color: #6a52ff;
        }
      }
    }
  }

  .action-buttons {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;

    @media (max-width: 768px) {
      justify-content: center;
      width: 100%;
    }

    .primary-btn {
      background: #2806f9;
      color: #ffffff;
      font-weight: 700;
      font-size: 14.5px;
      padding: 12px 24px;
      border-radius: 30px;
      text-decoration: none;
      transition: all 0.25s;
      display: inline-flex;
      align-items: center;
      gap: 8px;

      &:hover {
        background: #1e03c2;
        transform: translateY(-2px);
        color: #ffffff;
      }
    }

    .flyer-btn {
      background: rgba(255, 255, 255, 0.15);
      border: 1px solid rgba(255, 255, 255, 0.3);
      color: #ffffff;
      font-weight: 600;
      font-size: 13.5px;
      padding: 11px 18px;
      border-radius: 30px;
      cursor: pointer;
      display: inline-flex;
      align-items: center;
      gap: 8px;
      transition: all 0.25s;

      &:hover {
        background: rgba(255, 255, 255, 0.25);
        color: #ffffff;
      }
    }

    .social-btn {
      width: 42px;
      height: 42px;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.15);
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 17px;
      text-decoration: none;
      transition: all 0.25s;

      &.tiktok:hover {
        background: #000000;
        transform: scale(1.1);
      }

      &.youtube:hover {
        background: #ff0000;
        transform: scale(1.1);
      }
    }
  }
`;

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.88);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;
  padding: 20px;
  animation: fadeIn 0.2s ease-in-out;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  .modal-inner {
    position: relative;
    max-width: 980px;
    width: 100%;
    max-height: 92vh;
    background: #0c1538;
    border-radius: 14px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    box-shadow: 0 25px 50px rgba(0, 0, 0, 0.6);
    border: 1px solid #283768;

    img {
      width: 100%;
      height: auto;
      max-height: calc(92vh - 65px);
      object-fit: contain;
      display: block;
      background: #000;
    }

    .close-button {
      position: absolute;
      top: 12px;
      right: 14px;
      background: rgba(0, 0, 0, 0.7);
      color: #fff;
      border: 1px solid rgba(255, 255, 255, 0.4);
      width: 38px;
      height: 38px;
      border-radius: 50%;
      font-size: 18px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: background 0.2s;
      z-index: 10;

      &:hover {
        background: #e21b22;
      }
    }

    .modal-bottom {
      padding: 14px 22px;
      background: #0c1538;
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #fff;
      font-size: 14px;

      a {
        color: #6a52ff;
        text-decoration: none;
        font-weight: 700;
        display: flex;
        align-items: center;
        gap: 6px;
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
`;
